import { render, staticRenderFns } from "./AppDrawerClientes.vue?vue&type=template&id=760a2628&scoped=true&"
import script from "./AppDrawerClientes.vue?vue&type=script&lang=js&"
export * from "./AppDrawerClientes.vue?vue&type=script&lang=js&"
import style0 from "./AppDrawerClientes.vue?vue&type=style&index=0&id=760a2628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760a2628",
  null
  
)

export default component.exports